import React from "react"
import _ from "lodash"

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import LoaderButton from '../../Components/LoaderButton';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';
import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import ExpansionItem from '../../Components/ExpansionItem';
import Dialog from '../../Components/Dialog';
import BackButton from '../../Components/BackButton';

import AddIcon from '@material-ui/icons/Add';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';

const styles = theme => ({
    card: {
        width: "100%"
    },
    flex: {
        flex: 1
    },
    divider: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: -30,
        marginRight: -30
    },
    textAlignRight: {
        textAlign: "right"
    }
})

const columns = [
    "Anrede / Firmenname",
    "Land",
    "Plz",
    "Ort",
    "Adresse",
    "Telefon",
    "Mobil",
    "Email",
    "Internet",
    "Fax"
]

const options = {}

var KontaktFormular = ({handleChange, classes, data, id}) => {
    return (
        <Grid item xs={12}>

            <TextFieldHelper n={12} value={data.anrede} onChange={handleChange('anrede', false, id)} label="Anrede / Firmenname" />
            <Divider className={"divider"} />

            <Grid container spacing={8}>
                <TextFieldHelper n={6} value={data.vorname} onChange={handleChange('vorname', false, id)} label="Vorname" />
                <TextFieldHelper n={6} value={data.nachname} onChange={handleChange('nachname', false, id)} label="Nachname" />
            </Grid>
            <Divider className={"divider"} />

            <Grid container spacing={8}>
                <TextFieldHelper n={2} value={data.land} onChange={handleChange('land', true, id)} label="Land" />
                <TextFieldHelper n={4} value={data.plz} onChange={handleChange('plz', false, id)} label="PLZ" />
                <TextFieldHelper n={6} value={data.ort} onChange={handleChange('ort', false, id)} label="Ort" />
            </Grid>
            <Divider className={"divider"} />

            <TextFieldHelper n={12} value={data.adresse} onChange={handleChange('adresse', false, id)} label="Adresse / Straße" />
            <Divider className={"divider"} />

            <Grid container spacing={8}>
                <TextFieldHelper n={6} value={data.email} onChange={handleChange('email', false, id)} label="E-Mail Adresse" />
                <TextFieldHelper n={6} value={data.internet} onChange={handleChange('internet', false, id)} label="Internet" />
            </Grid>
            <Divider className={"divider"} />

            <Grid container spacing={8}>
                <TextFieldHelper n={4} value={data.telefon} onChange={handleChange('telefon', false, id)} label="Telefon" />
                <TextFieldHelper n={4} value={data.mobil} onChange={handleChange('mobil', false, id)} label="Mobil" />
                <TextFieldHelper n={4} value={data.fax} onChange={handleChange('fax', false, id)} label="Fax" />
            </Grid>
            <Divider className={"divider"} />

            <TextFieldHelper n={12} multiline value={data.notiz} onChange={handleChange('notiz', false, id)} label="Notiz" />
        </Grid>
    )
}

class KontaktDetail extends React.Component {

    state = {
        newEntry: {},
        newEntryAnsprechpartner: {},
        dialogOpen: false,
        putLoading: false,
        isLoading: true,
        ansprechpartner: null
    }

    componentDidMount() {
        this.props.doLoad(this.props.match.params.id)
        this.props.doLoad_Ansprechpartner(this.props.match.params.id)

        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "kontakte")
                var genericData_ansprechpartner = select(store.getState(), "ansprechpartner")

                if(this.state.newEntry.id === undefined) {
                    this.setState({
                        newEntry: genericData.data
                    })
                }

                if(this.state.isLoading) {
                    this.setState({
                        isLoading: genericData.isLoading
                    })
                }

                if(_.has(genericData_ansprechpartner, "dialogOpen") && this.state.dialogOpen !== genericData_ansprechpartner.dialogOpen) {
                    this.setState({
                        dialogOpen: genericData_ansprechpartner.dialogOpen
                    })
                }

                if(_.has(genericData, "putLoading") && this.state.putLoading !== genericData.putLoading) {
                    if(_.has(genericData.putLoading, this.state.newEntry.id)) {
                        this.setState({
                            putLoading: genericData.putLoading[this.state.newEntry.id]
                        })
                    }
                }
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleChange = (name, uppercase, id) => event => {

        var val = ""
        if(event._d !== undefined) {
            val = event._d
        } else {
            val = event.target.value
            if(event.target.type === "checkbox") {
                val = event.target.checked
            }
        }

        if(uppercase) {
            val = val.toUpperCase()
        }

        if(id !== undefined && id !== "new") {
            if(_.has(this.props, 'ansprechpartner.data')) {
                var itemKey = _.findKey(this.props.ansprechpartner.data, (o) => {
                    return o.id === id
                })
                this.props.ansprechpartner.data[itemKey][name] = val
                this.setState({
                    ansprechpartner: this.props.ansprechpartner.data
                })
            }
        } else if(id === "new") {
            this.state.newEntryAnsprechpartner[name] = val
            this.setState({
                newEntryAnsprechpartner: this.state.newEntryAnsprechpartner
            });
        } else {
            this.state.newEntry[name] = val
            this.setState({
                newEntry: this.state.newEntry
            });
        }

    }

    saveAction = () => {
        this.props.doPut(this.state.newEntry.id, this.state.newEntry)
    }

    populate = (data) => {
        this.props.doLoad(data)
    }

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    handleChangePanel = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    }

    deleteActionSub = (id) => {
        this.props.doDelete_Ansprechpartner(id)
    }

    saveActionSub = (id) => {
        var itemKey = _.findKey(this.props.ansprechpartner.data, (o) => {
            return o.id === id
        })
        this.props.doPut_Ansprechpartner(this.props.ansprechpartner.data[itemKey].id, this.props.ansprechpartner.data[itemKey])
    }

    postDataAnsprechpartner = () => {
        //this.state.newEntryAnsprechpartner.kontakt = {id: this.state.newEntry.id}
        this.state.newEntryAnsprechpartner.kontakt = this.state.newEntry.id
        this.state.newEntryAnsprechpartner.gruppe = this.state.newEntry.gruppe
        this.props.doPost_Ansprechpartner(this.state.newEntryAnsprechpartner)
        this.setState({
            newEntryAnsprechpartner: {}
        })
    }

    render() {

        var {
            classes
        } = this.props

        var {
            isLoading, putLoading, ansprechpartner, dialogOpen
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var {
            aktiv,
            anrede,
            vorname,
            nachname,
            land,
            plz,
            ort,
            adresse,
            notiz,
            email,
            internet
        } = this.state.newEntry

        var items = []
        var count = 0
        if(ansprechpartner === null && _.has(this.props, 'ansprechpartner.data') && this.props.ansprechpartner.data.length > 0) {
            items = this.props.ansprechpartner.data
            count = this.props.ansprechpartner.count
        }
        if(ansprechpartner !== null) {
            items = ansprechpartner
        }

        return (
            <div>

                <Toolbar>
                    <BackButton go={() => this.props.history.push("/kontakte")} />
                    <div className={classes.flex} />
                    <IconButton aria-label="Delete">
                        <DeleteForeverIcon />
                    </IconButton>
                </Toolbar>

                <Grid container spacing={8}>
                    <Grid item xs={5}>

                        <Card className={classes.card}>
                            <CardContent>

                                <Switch
                                    key={aktiv+"aktiv"}
                                    checked={aktiv}
                                    onChange={this.handleChange('aktiv')}
                                    value="aktiv"
                                /> {aktiv ? "Aktiv" : "Inaktiv"}

                                <Divider className={"divider"} />

                                <KontaktFormular classes={classes} handleChange={this.handleChange} data={this.state.newEntry} />

                            </CardContent>

                            <CardActions className="cardAction">
                                <LoaderButton name="Speichern" color="primary" onClick={this.saveAction} loading={this.state.putLoading} />
                            </CardActions>

                        </Card>

                    </Grid>

                    <Grid item xs={7}>
                        <Button onClick={() => this.setState({dialogOpen: true})}><AddIcon /> Neuer Ansprechpartner</Button>
                        {items.length === 0 && <p className="text-center no">Keine Ansprechpartner vorhanen</p>}
                        {items.map((item) => {

                                var name = "-"
                                var nameArr = []
                                if(item.anrede !== undefined) {
                                    nameArr.push(item.anrede)
                                }
                                if(item.vorname !== undefined) {
                                    nameArr.push(item.vorname)
                                }
                                if(item.nachname !== undefined) {
                                    nameArr.push(item.nachname)
                                }
                                if(nameArr.length > 0) {
                                    name = nameArr.join(" ")
                                }

                                var subtitle = ""
                                var subtitleArr = []
                                if(item.telefon) {
                                    subtitleArr.push("T: " + item.telefon)
                                }
                                if(item.mobil) {
                                    subtitleArr.push("M: " + item.mobil)
                                }
                                if(item.email) {
                                    subtitleArr.push("E: " + item.email)
                                }
                                if(subtitleArr.length > 0) {
                                    subtitle = subtitleArr.join(" // ")
                                }

                                return (
                                    <ExpansionItem
                                        key={item.id}
                                        id={item.id}
                                        expanded={this.state.expanded}
                                        handleChange={this.handleChangePanel}
                                        title={name}
                                        subtitle={subtitle}
                                        isLoading={_.has(putLoading[item.id]) && false}
                                        deleteAction={() => this.deleteActionSub(item.id)}
                                        saveAction={() => this.saveActionSub(item.id)}
                                    >
                                        <KontaktFormular classes={classes} handleChange={this.handleChange} data={item} id={item.id} />
                                    </ExpansionItem>
                                )
                            }
                        )}
                    </Grid>

                </Grid>

                <Dialog
                    title="Neuer Ansprechpartner"
                    saveAction={this.postDataAnsprechpartner}
                    closeAction={() => this.setState({dialogOpen: false, newEntryAnsprechpartner: {}})}
                    open={dialogOpen}
                >
                    <KontaktFormular classes={classes} handleChange={this.handleChange} id="new" data={this.state.newEntryAnsprechpartner} />
                </Dialog>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    kontakte: state.kontakte,
    ansprechpartner: state.ansprechpartner,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    doLoad_Ansprechpartner: (id) => dispatch(doLoad("ansprechpartner", "api/generic/ansprechpartner/list?kontakt="+id)),
    doPut_Ansprechpartner: (id, data) => dispatch(doPut("ansprechpartner", "api/generic/ansprechpartner/"+id, data)),
    doPost_Ansprechpartner: (data) => dispatch(doPost("ansprechpartner", "api/generic/ansprechpartner", data)),
    doDelete_Ansprechpartner: (id) => dispatch(doDelete("ansprechpartner", "api/generic/ansprechpartner/"+id, id)),

    doLoad: (id) => dispatch(doLoad("kontakte", "api/generic/kontakt/single/"+id)),
    doDelete: (id) => dispatch(doDelete("kontakte", "api/generic/kontakt/"+id, id)),
    doPut: (id, data) => dispatch(doPut("kontakte", "api/generic/kontakt/"+id, data)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(KontaktDetail));



// WEBPACK FOOTER //
// ./src/Routes/Kontakt/Detail.js